import { render } from "./MyCertView.vue?vue&type=template&id=749d72f2&scoped=true"
import script from "./MyCertView.vue?vue&type=script&lang=js"
export * from "./MyCertView.vue?vue&type=script&lang=js"

import "./MyCertView.vue?vue&type=style&index=0&id=749d72f2&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749d72f2"]])

export default __exports__